export const config = {
    env: process.env.VUE_APP_ENV,
    serverUrl: process.env.VUE_APP_SERVER_URL,
    administrationUrl: process.env.VUE_APP_ADMINISTRATION_URL,
    defaultLanguage: 'cz',
    en: 'en',
    cz: 'cz',

    authServer: {
        url: process.env.VUE_APP_AUTH_SERVER_URL,
        realm: process.env.VUE_APP_AUTH_REALM,
        clientId: 'mymendelu-web-administration',
    }
};
